var _rect, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWaFullcolor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.31543,
    width: 20,
    height: 20,
    rx: 10,
    fill: "url(#paint0_linear_161_14745)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 15.8179L5.10744 12.7042C4.57734 11.7903 4.29925 10.7553 4.30214 9.69727C4.30214 6.38181 7.01352 3.6862 10.3419 3.6862C11.9583 3.6862 13.4762 4.31182 14.6147 5.44772C15.756 6.58363 16.3846 8.09432 16.3817 9.70016C16.3817 13.0156 13.6703 15.7112 10.339 15.7112H10.3361C9.32515 15.7112 8.33155 15.4575 7.44804 14.9789L4.25 15.8179ZM7.60157 13.892L7.78406 14.0016C8.5546 14.4571 9.43812 14.6964 10.339 14.6993H10.3419C13.1083 14.6993 15.362 12.4592 15.362 9.70304C15.362 8.36821 14.8406 7.1141 13.8934 6.16847C12.9461 5.22285 11.6831 4.7039 10.3419 4.7039C7.57549 4.70102 5.32181 6.94112 5.32181 9.69727C5.32181 10.64 5.58541 11.5597 6.08945 12.3554L6.20822 12.5457L5.70128 14.3879L7.60157 13.892Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46191 15.6074L5.29039 12.6005C4.77766 11.7211 4.50826 10.7207 4.50826 9.70016C4.51116 6.50002 7.12694 3.89666 10.3424 3.89666C11.9037 3.89666 13.3666 4.50209 14.4674 5.59764C15.5681 6.69318 16.1736 8.15198 16.1736 9.70304C16.1736 12.9032 13.5549 15.5065 10.3424 15.5065H10.3395C9.36325 15.5065 8.40442 15.2615 7.55277 14.8002L4.46191 15.6074Z",
    fill: "url(#paint1_linear_161_14745)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 15.8179L5.10744 12.7042C4.57734 11.7903 4.29925 10.7553 4.30214 9.69727C4.30214 6.38181 7.01352 3.6862 10.3419 3.6862C11.9583 3.6862 13.4762 4.31182 14.6147 5.44772C15.756 6.58363 16.3846 8.09432 16.3817 9.70016C16.3817 13.0156 13.6703 15.7112 10.339 15.7112H10.3361C9.32515 15.7112 8.33155 15.4575 7.44804 14.9789L4.25 15.8179ZM7.60157 13.892L7.78406 14.0016C8.5546 14.4571 9.43812 14.6964 10.339 14.6993H10.3419C13.1083 14.6993 15.362 12.4592 15.362 9.70304C15.362 8.36821 14.8406 7.1141 13.8934 6.16847C12.9461 5.22285 11.6831 4.7039 10.3419 4.7039C7.57549 4.70102 5.32181 6.94112 5.32181 9.69727C5.32181 10.64 5.58541 11.5597 6.08945 12.3554L6.20822 12.5457L5.70128 14.3879L7.60157 13.892Z",
    fill: "url(#paint2_linear_161_14745)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83288 7.18329C8.7199 6.93247 8.60114 6.9267 8.49396 6.92382C8.40705 6.92094 8.30567 6.92094 8.20428 6.92094C8.10289 6.92094 7.94067 6.95842 7.80163 7.10833C7.66258 7.25825 7.27441 7.62151 7.27441 8.36244C7.27441 9.10049 7.81611 9.81548 7.89143 9.91638C7.96674 10.0173 8.93716 11.5828 10.4696 12.1853C11.7441 12.687 12.0048 12.586 12.28 12.5601C12.5552 12.5342 13.1722 12.1968 13.2997 11.8451C13.4243 11.4934 13.4243 11.1936 13.3866 11.1301C13.3489 11.0667 13.2476 11.0292 13.0969 10.9543C12.9463 10.8793 12.2047 10.516 12.0657 10.4642C11.9266 10.4151 11.8252 10.3892 11.7268 10.5391C11.6254 10.689 11.3357 11.0263 11.2488 11.1272C11.1619 11.2282 11.0721 11.2397 10.9215 11.1647C10.7708 11.0898 10.2842 10.9312 9.7077 10.418C9.2587 10.0202 8.95454 9.52718 8.86764 9.37726C8.78074 9.22734 8.85895 9.14662 8.93426 9.07166C9.00089 9.00535 9.0849 8.8958 9.16021 8.80931C9.23553 8.72282 9.2616 8.65939 9.31085 8.55849C9.36009 8.45758 9.33692 8.37109 9.29926 8.29613C9.2616 8.22406 8.96613 7.48024 8.83288 7.18329Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_161_14745",
    x1: 10.3149,
    y1: 19.999,
    x2: 10.3149,
    y2: -0.000699748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_161_14745",
    x1: 10.3174,
    y1: 15.6069,
    x2: 10.3174,
    y2: 3.89625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_161_14745",
    x1: 10.317,
    y1: 15.8168,
    x2: 10.317,
    y2: 3.6862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWaFullcolor);
export default __webpack_public_path__ + "static/media/icon-wa-fullcolor.7a951d421c7f3da1b9e075c760b76a57.svg";
export { ForwardRef as ReactComponent };